/**
 * Fetch available modules for current user
 * Endpoint: GET /users/modules
 */

import { axiosInstance } from '@configs/axios/axiosInstance';

import type { Module } from '../types/module.types';

export async function fetchModules(): Promise<Module[]> {
  const { data } = await axiosInstance.get<Module[]>('/users/modules');

  return data;
}
